// extracted by mini-css-extract-plugin
module.exports = {"root":"IconDelete_root__1m3Sy"};